import {
    usePartnerBranding,
    applyPartnerTheme,
} from "~/composables/usePartnerBranding"

/**
 * Applies the active co-branding partner's color palette (CSS variables) on the
 * client and keeps it in sync if the partner cookie changes during the session.
 */
export default defineNuxtPlugin(() => {
    const { activePartner } = usePartnerBranding()

    watch(
        activePartner,
        (partner) => applyPartnerTheme(partner),
        { immediate: true }
    )
})
